<template>
  <div class="list">
    <ul>
      <li v-for="(item, index) in list" @click="toDetail(item)">
        <topic-item :data="item" :dataType="item.dataType"></topic-item>
      </li>
    </ul>
  </div>
</template>

<script>
import TopicItem from '@/components/goods/topic/item';
export default {
  name: 'goodsList',
  components: {
    TopicItem,
  },
  data() {
    return {
      list: [],
      ids: decodeURIComponent(this.$route.query.ids),
    };
  },
  created() {
    if (this.ids) {
      this.$api.api_v3_album_list_by_ids_post({ data: { ids: this.ids.split(',') } }).then((e) => {
        this.list = e;
      });
    }
  },
  methods: {
    toDetail(item) {
      if (item.dataType == 1) {
        //专辑
        this.$router.push(`/goods/detail/${item.id}`);
      } else {
        //4 视频
        this.$router.push({
          path: '/goods/video',
          query: {
            albumId: item.id,
          },
        });
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
.list ul li {
  margin-bottom: 14px;
}

.list {
  padding: 14px 0;
}

.loading {
  text-align: center;
  vertical-align: middle;
  padding: 16px 0;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading img {
  width: 24px;
  animation: rotate 0.5s linear infinite;
}
</style>
